export default class DataSourceTypeLabelDto {
    DataSourceType: number;
    Reference: number;
    Label: string;

    constructor(dataSourceType: number, reference: number, label: string) {
        this.DataSourceType = dataSourceType;
        this.Reference = reference;
        this.Label = label;
    }
}